export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginGoToRegister: "login-goto-register-btn",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerSubmit: "register-submit-btn",
  registerGoToLogin: "register-goto-login-btn",
  logoutBtn: "header-logout-btn",
  tabEmail: "login-tab-email",
  tabMobile: "login-tab-mobile",
  otpPhoneInput: "otp-phone-input",
  otpNameInput: "otp-name-input",
  otpSendBtn: "otp-send-btn",
  otpCodeInput: "otp-code-input",
  otpVerifyBtn: "otp-verify-btn",
  otpResendBtn: "otp-resend-btn",
  otpChangePhoneBtn: "otp-change-phone-btn",
};

export const DASH = {
  root: "dashboard-root",
  cardTotalLent: "kpi-total-lent",
  cardPending: "kpi-pending",
  cardOverdue: "kpi-overdue",
  cardRecovered: "kpi-recovered",
  newLoanBtn: "dashboard-new-loan-btn",
  loanRow: (id) => `loan-row-${id}`,
  loansTable: "dashboard-loans-table",
};

export const NEW_LOAN = {
  aiTextarea: "new-loan-ai-textarea",
  aiExtractBtn: "new-loan-ai-extract-btn",
  borrowerName: "new-loan-borrower-name",
  borrowerPhone: "new-loan-borrower-phone",
  amount: "new-loan-amount",
  interest: "new-loan-interest",
  tenure: "new-loan-tenure",
  purpose: "new-loan-purpose",
  saveBtn: "new-loan-save-btn",
};

export const LOAN = {
  root: "loan-detail-root",
  copyShareBtn: "loan-copy-share-btn",
  whatsappBtn: "loan-whatsapp-share-btn",
  backBtn: "loan-back-btn",
  markRecoveredBtn: "loan-mark-recovered-btn",
  addPaymentAmount: "loan-add-payment-amount",
  addPaymentUpiRef: "loan-add-payment-upi-ref",
  addPaymentNote: "loan-add-payment-note",
  addPaymentSubmit: "loan-add-payment-submit",
  deletePaymentBtn: (id) => `loan-delete-payment-${id}`,
  paymentRow: (id) => `loan-payment-row-${id}`,
  downloadAgreementBtn: "loan-download-agreement-btn",
  downloadDpnBtn: "loan-download-dpn-btn",
  sendReminderBtn: "loan-send-reminder-btn",
  reminderToneFriendly: "loan-reminder-tone-friendly",
  reminderToneFirm: "loan-reminder-tone-firm",
  reminderToneFinal: "loan-reminder-tone-final",
};

export const REPORTS = {
  root: "reports-root",
  timeseriesChart: "reports-timeseries-chart",
  splitChart: "reports-status-split-chart",
  topBorrowersList: "reports-top-borrowers-list",
  remindersChart: "reports-reminders-chart",
  topRemindedList: "reports-top-reminded-list",
  headerLink: "header-reports-link",
};

export const CONSENT = {
  root: "consent-root",
  agreeBtn: "consent-agree-btn",
  declineBtn: "consent-decline-btn",
  signatureInput: "consent-signature-input",
};

export const ONBOARDING = {
  root: "onboarding-root",
  progress: "onboarding-progress",
  // Step 1 - Welcome
  welcomeStartBtn: "onboarding-welcome-start-btn",
  welcomeSkipBtn: "onboarding-welcome-skip-btn",
  // Step 2 - Mobile
  mobilePhoneInput: "onboarding-mobile-phone-input",
  mobileSendOtpBtn: "onboarding-mobile-send-otp-btn",
  mobileCodeInput: "onboarding-mobile-code-input",
  mobileVerifyBtn: "onboarding-mobile-verify-btn",
  mobileContinueBtn: "onboarding-mobile-continue-btn",
  // Step 3 - ID
  idTypeSelect: (t) => `onboarding-id-type-${t}`,
  idFileInput: "onboarding-id-file-input",
  idUploadBtn: "onboarding-id-upload-btn",
  idFullName: "onboarding-id-fullname",
  idDob: "onboarding-id-dob",
  idGender: "onboarding-id-gender",
  idAddress: "onboarding-id-address",
  idContinueBtn: "onboarding-id-continue-btn",
  // Step 4 - Selfie + GPS
  selfieCaptureBtn: "onboarding-selfie-capture-btn",
  selfieRetakeBtn: "onboarding-selfie-retake-btn",
  selfieUseBtn: "onboarding-selfie-use-btn",
  selfieContinueBtn: "onboarding-selfie-continue-btn",
  requestLocationBtn: "onboarding-request-location-btn",
  // Step 5 - Submit
  submitBtn: "onboarding-submit-btn",
  // Step 6 - Success
  goToDashboardBtn: "onboarding-goto-dashboard-btn",
};
